import { useTimeTransform } from '@hooks/useTimeTransform';
import { GroupReportPointModel } from '@models/ReportModel';
import { meanBy, sumBy } from 'lodash-es';
import { useMemo } from 'react';

const useAvarageGrouping = (
  data: GroupReportPointModel<Record<string, any> & { duration: number }>[],
): [number, ReturnType<typeof convertSecondToTwoDigitFormat>] => {
  const grouped = useMemo(
    () =>
      data.reduce((acc, point) => {
        // here we ignore days with no data
        if (!point?.points) return acc;

        const sumDuration = sumBy(point.points, 'duration');
        //total number of points with some activity
        const { length } = point.points;

        //total number of points with FINISHED activity
        const activityLength = point.points.filter(item => !item.active).length;
        if (length === 0 || sumDuration === 0) return acc;
        acc.push({ activity: activityLength, duration: sumDuration });

        return acc;
      }, []),
    [data],
  );

  const { convertSecondToTwoDigitFormat } = useTimeTransform();
  const inactiveGrouped = grouped.filter(item => item.activity > 0);
  const averageActivity = Math.round(
    inactiveGrouped.length ? meanBy(inactiveGrouped, item => item.activity) : 0,
  );
  const duration = convertSecondToTwoDigitFormat(
    grouped.length ? meanBy(grouped, item => item.duration) : 0,
  );

  return [averageActivity, duration];
};

export default useAvarageGrouping;
